export const isServer = () => typeof window === 'undefined';

export const isCookieAccepted = (cookie) => {
  const cookies = document.cookie.split('; ').reduce((acc, c) => {
    const [name, value] = c.split('=');
    return { ...acc, [name]: decodeURIComponent(value) };
  }, {});

  return cookies[cookie] === 'true';
};


// WEBPACK FOOTER //
// ./src/util/cookies.js